import { render, staticRenderFns } from "./RoleEditSettings.vue?vue&type=template&id=2d875dec&"
import script from "./RoleEditSettings.vue?vue&type=script&lang=js&"
export * from "./RoleEditSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports